if (!customElements.get("product-form")) {
	customElements.define(
		"product-form",
		class ProductForm extends HTMLElement {
			constructor() {
				super();

				this.form = this.querySelector("form");
				this.form.querySelector("[name=id]").disabled = false;
				this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
				this.cart =
					document.querySelector("cart-notification") ||
					document.querySelector("cart-drawer");
				this.submitButton = this.querySelector('[type="submit"]');
				if (document.querySelector("cart-drawer"))
					this.submitButton.setAttribute("aria-haspopup", "dialog");

					this.hideErrors = this.dataset.hideErrors === "true";
			}

			async onSubmitHandler(evt) {
				evt.preventDefault();
				if (this.submitButton.getAttribute("aria-disabled") === "true") return;
                let cart = await getCurrentCart()
                let hasGift = await checkForGift(cart)
                if(hasGift){
                    this.handleErrorMessage("No puedes agregar un producto si tienes una Gift Card en tu carrito");
                    return
                }
				if (this.submitButton.getAttribute("gift-card") == "true"){
                  if(cart.item_count > 0){
                      this.handleErrorMessage('No puedes comprar una Gift Card si ya tienes un producto en tu carrito');
                      return
                  }
                  const name = document.getElementById('name');
                  const phone = document.getElementById('phone');
                  const email = document.getElementById('email');
                  const from = document.getElementById('from');
                  const date = document.getElementById('date');
                  const time = document.getElementById('time');
                  const message = document.getElementById('message');
                  if(!message.value.trim()){
                    message.value = 'Ecard'
                  }
                  
                  if (
                      !name.value.trim() ||
                      !phone.value.trim() ||
                      !email.value.trim() ||
                      !from.value.trim() ||
                      !date.value.trim() ||
                      !time.value.trim()
                    ) {
                      const alertElement = document.getElementById('gc-alert');
                      $('#gc-alert-message').text('Por favor, llena todos los campos')
                      alertElement.removeAttribute('hidden');
                      return;
                    }
                }

				this.handleErrorMessage();

				this.submitButton.setAttribute("aria-disabled", true);
				this.submitButton.classList.add("loading");
				//this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

				const config = fetchConfig("javascript");
				config.headers["X-Requested-With"] = "XMLHttpRequest";
				delete config.headers["Content-Type"];

				const formData = new FormData(this.form);
				if(currentVariant != null){
					formData.append('id', currentVariant);
				}
				if(variantColor != undefined){
					formData.append('properties[color]', variantColor);
				}
				if (this.cart) {
					formData.append(
						"sections",
						this.cart.getSectionsToRender().map((section) => section.id)
					);
					formData.append("sections_url", window.location.pathname);
					this.cart.setActiveElement(document.activeElement);
				}
				config.body = formData;
				fetch(`${routes.cart_add_url}`, config)
					.then((response) => response.json())
					.then((response) => {
						ncaddToken();
						uploadCart();
                      executeInCartUpdate()
						const url = new URL(window.location.href);
						const isFromNostoSearch = url.searchParams.get("fromnostosearch");
						if (isFromNostoSearch) Nosto.reloadCartWithFlags({ skipEvents: true });
						if (response.status) {
							publish(PUB_SUB_EVENTS.cartError, {
								source: "product-form",
								productVariantId: formData.get("id"),
								errors: response.description,
								message: response.message,
							});
							this.handleErrorMessage(response.description);

							const soldOutMessage =
								this.submitButton.querySelector(".sold-out-message");
							if (!soldOutMessage) return;
							this.submitButton.setAttribute("aria-disabled", true);
							this.submitButton.querySelector("span").classList.add("hidden");
							soldOutMessage.classList.remove("hidden");
							this.error = true;
							return;
						} else if (!this.cart) {
							window.location = window.routes.cart_url;
							return;
						}

						if (!this.error)
							publish(PUB_SUB_EVENTS.cartUpdate, {
								source: "product-form",
								productVariantId: formData.get("id"),
							});
						this.error = false;
						const quickAddModal = this.closest("quick-add-modal");
						if (quickAddModal) {
							document.body.addEventListener(
								"modalClosed",
								() => {
									setTimeout(() => {
										this.cart.renderContents(response);
									});
								},
								{ once: true }
							);
							quickAddModal.hide(true);
						} else {
							this.cart.renderContents(response);
						}
					})
					.catch((e) => {
						console.error(e);
					})
					.finally(() => {
						this.submitButton.classList.remove("loading");
						if (this.cart && this.cart.classList.contains("is-empty"))
							this.cart.classList.remove("is-empty");
						if (!this.error) this.submitButton.removeAttribute("aria-disabled");
						//this.querySelector('.loading-overlay__spinner').classList.add('hidden');
					});
			}

			handleErrorMessage(errorMessage = false) {
				if (this.hideErrors) return;
				
				this.errorMessageWrapper =
					this.errorMessageWrapper ||
					this.querySelector(".product-form__error-message-wrapper");
				if (!this.errorMessageWrapper) return;
				this.errorMessage =
					this.errorMessage ||
					this.errorMessageWrapper.querySelector(
						".product-form__error-message"
					);

				this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

				if (errorMessage) {
					this.errorMessage.textContent = errorMessage;
				}
			}
		}
	);
}


async function checkForGift(cart){
  console.log('Revisa si hay Gift')
  let sku_list = ['9909909_000100','9909909_000200','9909909_000300','9909909_000400']
  for(let item of cart.items){
    if(sku_list.includes(item.sku)){
      return true
    }
  }
  return false
}

async function getCurrentCart() {
	let cart
    await fetch('/cart.js')
    .then(response => {
      if (!response.ok) {
        return response.json().then(error => { throw new Error(error.message); });
      }
      return response.json();
    })
    .then(data => {
        cart = data
    })
    .catch((error) => {
      console.error('Error:', error);
    });
    return cart
  }